// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-control[data-v-169927fc] {\n  font-size: 1.2rem;\n}\n", ""]);
// Exports
module.exports = exports;
